import { Link } from "@inertiajs/react";
import { Building2 } from "lucide-react";
import { DetailItem } from "@/bizminer/Admin/InsightRequests/_components/DetailItem.tsx";
import { CompanyLogo } from "@/components/CompanyLogo.tsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import {
  bizminer_admin_organization_account_path,
  bizminer_admin_organization_path,
} from "@/routes";
import type { BizminerAdminInsightRequestDetail } from "@/types/serializers";

export const ContextCard = ({
  insightRequest,
}: {
  insightRequest: BizminerAdminInsightRequestDetail;
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Building2 className="h-5 w-5" />
        Context
      </CardTitle>
    </CardHeader>
    <CardContent>
      <dl className="space-y-4">
        <DetailItem label="Organization">
          <Link
            href={bizminer_admin_organization_path(
              insightRequest.organization.id,
            )}
            className="text-primary hover:text-primary/80"
          >
            {insightRequest.organization.name}
          </Link>
          <span className="text-muted-foreground ml-2">
            ({insightRequest.organization.slug})
          </span>
        </DetailItem>
        <DetailItem label="Account">
          <div className="flex items-center gap-2">
            <CompanyLogo
              logoUrl={insightRequest.account.logo_url}
              name={insightRequest.account.name}
              className="h-5 w-5"
            />
            <Link
              href={bizminer_admin_organization_account_path(
                insightRequest.organization.id,
                insightRequest.account.id,
              )}
              className="text-primary hover:text-primary/80"
            >
              {insightRequest.account.name}
            </Link>
          </div>
        </DetailItem>
        <DetailItem label="Strategic Pillar">
          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-mono bg-secondary text-secondary-foreground">
            {insightRequest.pillar_insight.slug}
          </span>
          <span className="ml-2 text-muted-foreground">
            {insightRequest.pillar_insight.title}
          </span>
        </DetailItem>
      </dl>
    </CardContent>
  </Card>
);
